import { createContext } from 'react';
export const NavigationContext = createContext({
  isLeftSidebarOpen: false,
  isTopNavigationOpen: false,
  toggleTopNavigation: () => null
});